import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const testimonialSlice = createSlice({
  name: "testimonial",
  initialState,
  reducers: {
    fetchTestimonials: (state) => {
      state.loading = true;
    },
    fetchTestimonialsSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchTestimonialsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchTestimonials,
  fetchTestimonialsSuccess,
  fetchTestimonialsFailure,
} = testimonialSlice.actions;

export default testimonialSlice.reducer;
